/*
 * @Description: 直接全部用对象，不用枚举，反而更方便遍历
 */

export const ROLE_TYPE = {
  PRIMARY: 0,
  MEDIUM: 1,
  ADMIN: -1,
}

// 出席状态
export const ATTEND_STATUS = {
  ABSENT: 0,
  ATTENDED: 1,
}
export const ATTEND_STATUS_DESC = {
  [ATTEND_STATUS.ABSENT]: 'Absent', // 未出席
  [ATTEND_STATUS.ATTENDED]: 'Attended', // 已出席
}

// 老师反馈状态
export const FEED_BACK_STATUS = {
  NO: 0,
  HAD: 1,
}
export const FEED_BACK_STATUS_DESC = {
  [FEED_BACK_STATUS.NO]: 'No Feedback', // 未反馈
  [FEED_BACK_STATUS.HAD]: 'Feedback Provided', // 已反馈
}

// 课次状态
export const LESSON_STATUS = {
  NO: 'NO',
  ON: 'ON',
  CO: 'CO',
  CANCEL: 'CANCEL',
  RESCHEDULE: 'RESCHEDULE',
  TEA_NOT_ATTEND: 'TEA_NOT_ATTEND',
  STU_NOT_ATTEND: 'STU_NOT_ATTEND',
}
export const LESSON_STATUS_DESC = {
  [LESSON_STATUS.NO]: 'Not started', // 未开始
  [LESSON_STATUS.ON]: 'In Progress', // 进行中
  [LESSON_STATUS.CO]: 'Completed', // 已完成
  [LESSON_STATUS.CANCEL]: 'Cancelled', // 已取消
  [LESSON_STATUS.RESCHEDULE]: 'Rescheduled', // 已改约
  [LESSON_STATUS.TEA_NOT_ATTEND]: 'Teacher Absent', // 老师缺席
  [LESSON_STATUS.STU_NOT_ATTEND]: 'Student Absent', // 学生缺席
}

// 新签意向
export const INTENTION = {
  HIGH: 2,
  MEDIUM: 1,
  LOW: 0,
  NO: 3,
};
export const INTENTION_DESC = {
  [INTENTION.HIGH]: 'High', // 高意向
  [INTENTION.MEDIUM]: 'Medium', // 中意向
  [INTENTION.LOW]: 'Low', // 低意向
  [INTENTION.NO]: 'No', // 无意向
};
export const INTENTION_COLOR = {
  [INTENTION.HIGH]: '#ff4d4f', // 高意向
  [INTENTION.MEDIUM]: '#faad14', // 中意向
  [INTENTION.LOW]: '#1890ff', // 低意向
  [INTENTION.NO]: '#000000d9', // 无意向
};

// 英语基础
export const ENGLISH_FOUNDATION = {
  ZERO: 0,
  BASAL: 1,
  INDUCTION: 2,
  BASIC_READING: 3,
  COMMUNICATE: 4,
  BASIC_WRITE: 5,
  FLUENCY: 6,
}
export const ENGLISH_FOUNDATION_LONG_DESC = {
  [ENGLISH_FOUNDATION.ZERO]: 'Beginner: Has never studied English', // 0基础
  [ENGLISH_FOUNDATION.BASAL]: 'Elementary: Knows simple letters and a few words, like "apple" and "cat"', // 基础水平
  [ENGLISH_FOUNDATION.INDUCTION]: 'Basic Conversational: Can do simple greetings and self-introductions, like "Hello, my name is..."', // 入门对话
  [ENGLISH_FOUNDATION.BASIC_READING]: 'Basic Reading: Can understand simple storybooks or texts and answer some basic questions', // 基础阅读
  [ENGLISH_FOUNDATION.COMMUNICATE]: 'Everyday Conversational: Can have relatively fluent everyday conversations, such as discussing daily plans and hobbies.', // 日常交流
  [ENGLISH_FOUNDATION.BASIC_WRITE]: 'Basic Writing: Can write simple sentences or short essays, like describing their family or school life', // 初步写作
  [ENGLISH_FOUNDATION.FLUENCY]: 'Fluent: Can comfortably use English for listening, speaking, reading, and writing, and understand most classroom content', // 流利
}










/**
 * 将这个文件中的枚举对象转换成 @ant-design/pro-components 的 valueEnum 对象
 * @param obj 字典对象，如：ATTEND_STATUS
 * @param desc 字典对象中各字段的描述，如：ATTEND_STATUS_DESC
 * @param statusesOptional 字典对象中各字段的状态，如：(如果不传，则输出的结果中不会有“status”字段)
      const ATTEND_STATUS_STATUS = {
        [ATTEND_STATUS.ABSENT]: 'Error', // 未出席
        [ATTEND_STATUS.ATTENDED]: 'Success', // 已出席
      }
 * @returns {IValueEnum} 
      {
        [key: string]:
          {
            text: ReactNode;
            status: 'Success' | 'Error' | 'Processing' | 'Warning' | 'Default';
          };
      }
 */
export const transToValueEnum = (obj: any, desc: any, statusesOptional: any = null) => {
  const result: any = {};

  Object.values(obj).forEach((enumObjVal: any) => {
    const text = desc[enumObjVal];
    const status = statusesOptional ? statusesOptional[enumObjVal] : undefined;
    result[enumObjVal] = status ? { text, status } : { text };
  });

  return result;
}

/**
 * 将这个文件中的枚举对象转换成数组
 * @param obj 字典对象，如：ATTEND_STATUS
 * @param desc 字典对象中各字段的描述，如：ATTEND_STATUS_DESC
 * @param fieldNames 自定义节点 label、value
 * @returns {Array} [{ label: 'xxx', value: xxx }]
 */
export const transToArray = (obj: any, desc: any, fieldNames = { label: 'label', value: 'value' }) => {
  // 提取 obj 对象中所有的值
  const values = Object.values(obj);

  // 根据这些值创建一个包含动态字段的对象数组
  return values.map((value: any) => ({
    [fieldNames.label]: desc[value],
    [fieldNames.value]: value,
  }));
}